import { apiSlice } from '../../api/api';

export const riskprofileApi = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getRiskProfile: builder.query({
      query: (params = {}) => ({
        url: '/operations/getallriskprofileusers',
        method: 'GET',
        params: {
          page: params.page || 1,
          search: params.search || '',
          ...params,
        },
      }),
      providesTags: ['RiskProfile'],
    }),
  }),
});

export const { useGetRiskProfileQuery } = riskprofileApi;